import { IDotXetChungChi } from "../../model/response/xet-chung-chi/IDotXetChungChi";
import { apiClient } from "../apiClient";

export const DOT_XET_CHUNG_CHI_API = "dot-xet-chung-chi";
export const dotXetChungChiApi = {
    SelectAll: () => apiClient.get(DOT_XET_CHUNG_CHI_API),
    Insert: (payload: IDotXetChungChi) => apiClient.post(DOT_XET_CHUNG_CHI_API, payload),
    Update: (id: number, payload: IDotXetChungChi) => apiClient.put(`${DOT_XET_CHUNG_CHI_API}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${DOT_XET_CHUNG_CHI_API}/${id}`),
}